import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {IngenieroAgronomoCore} from "../../../../../chacra-core/models/ingenieros-agronomos";

export const ingenierosAgronomosAdapter: EntityAdapter<IngenieroAgronomoCore> = createEntityAdapter<IngenieroAgronomoCore>({
  selectId: model => model.ingenieroAgronomoId,
  sortComparer: (a: IngenieroAgronomoCore, b: IngenieroAgronomoCore): number =>
    b.ingenieroAgronomoId
      .toString()
      .localeCompare(a.ingenieroAgronomoId.toString())
});

export interface IngenierosAgronomosState
  extends EntityState<IngenieroAgronomoCore> {
  isLoading?: boolean;
  error?: string | null;
}

export const initialState: IngenierosAgronomosState = ingenierosAgronomosAdapter.getInitialState(
  {
    isLoading: false,
    error: null
  }
);
